<template>
    <div>
        <el-drawer
            :visible.sync="dialogFormVisible"
            :direction="direction"
            :show-close="false"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            :size="screenWidth <= 976 ? '85%' : '500px'"
            @closed="initview">
            <div slot="title" class="header">
                <div class="drawer-title">YouTube Premium 문제 해결</div>
            </div>
            <div class="drawer-content" v-if="workorderflag">
                <el-button class="btn" @click="getNewLink">새 링크 받은 후 새 계정으로 등록하세요</el-button>
                <el-button class="btn" @click="rechargeToMyAccount" v-if="times>=15">본인의 계정에 충전</el-button>
                <el-button class="btn" @click="useAlongshareAccount">Alongshare 계정 사용</el-button>
                <el-button class="btn" @click="waitFamilyGroup">가족 그룹 복구 대기(이 기간 동안 그룹을 탈퇴하지 마세요)</el-button>
                <el-button class="btn" @click="failureAgainAfterRecovery">복구후 다시 오류</el-button>
            </div>
            <div class="drawer-content" v-if="!workorderflag">
                <div class="tip">
                    <span>처리 상태가 제출되었습니다.현재 처리 진행 상황：</span>
                </div>
                <div class="progress-container">  <el-progress type="circle" :percentage="workpercentage" :stroke-width="10"></el-progress></div>
            </div>
            <div class="dialog-footer footer-btn">
                <el-button class="btn cancel-btn" @click="dialogFormVisible = false">Close</el-button>
            </div>
        </el-drawer>

        <!-- 获取新链接 弹窗 -->
        <el-drawer
            :visible.sync="getNewLinkDialog"
            :direction="direction"
            :show-close="false"
            :close-on-press-escape="false"
            :size="screenWidth <= 976 ? '85%' : '500px'"
            :close-on-click-modal="false">
            <div slot="title" class="header">
                <div class="drawer-title">새 링크 받기</div>
            </div>
            <div class="drawer-content">
                <div class="tip">
                    주의 사항: 새 링크를 받으려면 가입하신 가족 그룹을 탈퇴해야 합니다. 기존 계정은 12개월 간의 가입 제한이 발생할 수 있으니 새로운 youtube계정이 필요합니다. 새로운 youtube계정을 입력하세요.(최선을 다해 해결중입니다. 일반적으로 72～360시간 이내 소요됩니다.)
                </div>
                <el-form :model="form" :rules="rules" ref="ruleForm">
                    <el-form-item prop="content">
                        <el-input v-model="form.email" placeholder="YouTube login email"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div  class="dialog-footer">
                <el-button class="btn cancel-btn" @click="getNewLinkDialog = false">Cancel</el-button>
                <el-button class="btn confirm-btn" type="primary" @click="submitNewLink">Confirm</el-button>
            </div>
        </el-drawer>
        
        <!-- 充值到自己的账号 弹窗 -->
        <el-drawer
            :visible.sync="rechargeToMyAccountDialog"
            :direction="direction"
            :show-close="false"
            :close-on-press-escape="false"
            :size="screenWidth <= 976 ? '85%' : '500px'"
            :close-on-click-modal="false">
            <div slot="title" class="header">
                <div class="drawer-title">본인의 계정에 충전</div>
                <a href="https://alongshare.crisp.help/ko/article/youtube-8-opm3ov/" target="_blank" class="how-use"> ➡️  How to use?</a>
            </div>
            <div class="drawer-content">
                <div class="tip">
                    주의 사항:본인의 계정으로 충전하는 경우: 
                    ⚠️ 개인 계정으로 충전하시는 경우, 최소 3개월 분의 구독료가 공제됩니다. 개인 연회비 구매 비용이 인상되었으므로, 이 옵션을 선택하시기 전에 신중하게 고려해 주시기 바랍니다.
                    2단계 인증을 활성화하세요. 그리고 정확한 이메일과 비밀번호를 제공하세요(최선을 다해 해결중입니다. 일반적으로 72～360시간 이내 소요됩니다.)
                </div>
                <el-form :model="form" :rules="rules" ref="ruleForm">
                    <el-form-item prop="content">
                        <el-input v-model="form.email" placeholder="YouTube login email"></el-input>
                    </el-form-item>
                    <el-form-item prop="password" style="width: 100%">
                        <el-input v-model="form.password" placeholder="input YouTube login password"></el-input>
                    </el-form-item>
                    <el-form-item prop="code1" style="width: 100%">
                        <el-input v-model="form.code1" placeholder="Backup Code 1 (8 digits)"></el-input>
                    </el-form-item>
                    <el-form-item prop="code2" style="width: 100%">
                        <el-input v-model="form.code2" placeholder="Backup Code 2 (8 digits)"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button class="btn cancel-btn" @click="rechargeToMyAccountDialog = false"> Cancel</el-button>
                <el-button class="btn confirm-btn" type="primary" @click="submitRechargeToMyAccount">Confirm</el-button>
            </div>
        </el-drawer>
        
        <!-- 使用alongshare提供的账号 弹窗 -->
        <el-drawer
            :visible.sync="useAlongshareAccountDialog"
            :direction="direction"
            :show-close="false"
            :close-on-press-escape="false"
            :size="screenWidth <= 976 ? '85%' : '500px'"
            :close-on-click-modal="false">
            <div slot="title" class="header">
                <div class="drawer-title">Alongshare 계정 사용</div>
            </div>
            <div class="drawer-content">
                <div class="tip">
                    주의 사항: Alongshare에서 제공한 계정을 사용하려면 계정 사용 제한을 방지하기 위해 비밀번호를 변경하고 보조 이메일 추가하세요. (최선을 다해 해결중입니다. 일반적으로 72～360시간 이내 소요됩니다.)
                </div>
            </div>
            <div class="dialog-footer">
                <el-button class="btn cancel-btn" @click="useAlongshareAccountDialog = false">Cancel</el-button>
                <el-button class="btn confirm-btn" type="primary" @click="submitUseAlongshareAccount">Confirm</el-button>
            </div>
        </el-drawer>
        
        <!-- 等待家庭群组恢复 弹窗 -->
        <el-drawer
            :visible.sync="waitFamilyGroupDialog"
            :direction="direction"
            :show-close="false"
            :close-on-press-escape="false"
            :size="screenWidth <= 976 ? '85%' : '500px'"
            :close-on-click-modal="false">
            <div slot="title" class="header">
                <div class="drawer-title">가족 그룹 복구 대기</div>
            </div>
            <div class="drawer-content">
                <div class="tip">
                    주의 사항: 가족 그롭의 회복을 기다리고 있으시면 그룹을 탈퇴하지 마세요. 복구 완료시 즉시 사용 가능합니다.(최선을 다해 해결중입니다. 일반적으로 72～360시간 이내 소요됩니다.)
                </div>
            </div>
            <div class="dialog-footer">
                <el-button class="btn cancel-btn" @click="waitFamilyGroupDialog = false">Cancel</el-button>
                <el-button class="btn confirm-btn" type="primary" @click="submitWaitFamilyGroup">Confirm</el-button>
            </div>
        </el-drawer>
        
        <!-- 恢复后再次失效 -->
        <el-drawer
            :visible.sync="failureAgainAfterRecoveryDialog"
            :direction="direction"
            :show-close="false"
            :close-on-press-escape="false"
            :size="screenWidth <= 976 ? '85%' : '500px'"
            :close-on-click-modal="false">
            <div slot="title" class="header">
                <div class="drawer-title">복구후 다시 오류</div>
            </div>
            <div class="drawer-content">
                <div class="tip">
                    주의 사항: 계정 정상적으로 회복한 후 다시 로그인 안되는 경우,
                    가족 그롭을 탈퇴하지 마시고 저희가 메세지를 받은 48～180시간 이내 해결해드리겠습니다.
                </div>
            </div>
            <div class="dialog-footer">
                <el-button class="btn cancel-btn" @click="failureAgainAfterRecoveryDialog = false">Cancel</el-button>
                <el-button class="btn confirm-btn" type="primary" @click="submitFailureAgainAfterRecovery">Confirm</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {
    getUserInfo,
    // isEmpty,
    // formatObj,
    // filterObj,
    MessageError,
    // startLoading
} from "@/util/util"
import {
    insertWorkorder,
    getToytbWorkorder
    // calprice,
    // payssion,
    // paytypeall,
    // stripe
} from "@/request/requests";
export default {
    name: "toytb",
    props: {
        pageName: {
            type: String,
            default: () => {
                return 'toytb'
            }
        },

    },
    data() {
        return {
            dialogFormVisible: false,
            getNewLinkDialog: false,
            rechargeToMyAccountDialog: false,
            useAlongshareAccountDialog: false,
            waitFamilyGroupDialog: false,
            failureAgainAfterRecoveryDialog: false,
            workpercentage:1,
            direction: 'btt',
            screenWidth: null,
            workorderflag:true,
            // tipDialog: false,
            item: {},
            times: null,
            form: this.initform(),
            rules: {
                email: [{
                    required: true,
                    message: "Please enter the Email",
                    trigger: "blur",
                },],
                password: [{
                    required: true,
                    message: "Please enter the Password",
                    trigger: "blur",
                },],
                code1: [{
                    required: true,
                    message: "Please enter the Code1",
                    trigger: "blur",
                },],
                code2: [{
                    required: true,
                    message: "Please enter the Code2",
                    trigger: "blur",
                },],
            },
        }
    },
    methods: {
        init(item,getToytbWorkorderdata) {
            this.dialogFormVisible = true;
            console.log(item);
            this.item = item;
            this.times = this.$moment(item.endTime).diff(this.$moment(new Date()), 'months')
            // console.log("TCL: init -> this.$moment(item.endTime).diff(this.$moment(new Date()), 'months')", this.$moment(item.endTime).diff(this.$moment(new Date()), 'months'))
            if(getToytbWorkorderdata){
                this.workorderflag = false;
                this.workpercentage =(1/(getToytbWorkorderdata.previousWorkordersCount+1)*100).toFixed(2); 
            }else{
                this.workorderflag = true;
            }
        },
        // async getToytbWorkorder() {
        //     const userInfo = JSON.parse(getUserInfo());
        //     this.form.userid = userInfo.id;
        //     let res = await getToytbWorkorder(this.form);
        //     if(res.status == "200"){
        //        if(res.data){
        //         this.workorderflag = false;
		// 		console.log("TCL: getToytbWorkorder -> this.workorderflag", this.workorderflag)
        //         this.workpercentage =parseInt(1/(res.data.previousWorkordersCount+1)*100); 
		// 		console.log("TCL: getToytbWorkorder -> this.workpercentage", this.workpercentage)
        //        }else{
        //         this.workorderflag = true;
        //        }
        //     }
        //     // console.log(res);
        // },
        initform() {
            return {
                id: "", // 序号
                userid: "", // 用户id
                workorderno: "", // 工单号
                ticketid: "", // 车票id
                typeid: "", // 类型id
                content: "", // 工单内容
                status: "", // 状态
                reply: "", // 处理回复
                orderId: "",
                code1: "",
                code2: "",
                password: "",
                email: "",
                ext1: "",//存剩余日期
            };
        },
        initview() {
            this.dialogFormVisible = false;
            this.getNewLinkDialog = false;
            this.rechargeToMyAccountDialog = false;
            this.useAlongshareAccountDialog = false;
            this.waitFamilyGroupDialog = false;
            this.failureAgainAfterRecoveryDialog = false;

        },
        getNewLink() {
            console.log('getNewLink');
            this.getNewLinkDialog = true;
        },
        rechargeToMyAccount() {
            console.log('rechargeToMyAccount');
            this.rechargeToMyAccountDialog = true;
        },
        useAlongshareAccount() {
            console.log('useAlongshareAccount');
            this.useAlongshareAccountDialog = true;
        },
        waitFamilyGroup() {
            console.log('waitFamilyGroup');
            this.waitFamilyGroupDialog = true;
        },
        failureAgainAfterRecovery() {
            console.log('failureAgainAfterRecovery');
            this.failureAgainAfterRecoveryDialog = true;
        },
        // isEmpty,
        // formatObj,
        // filterObj,
        async submitUser(ticketid, loginemail) {
            if ("" != this.form.content.trim() && null != this.form.content) {
                // this.$alert(this.$t("subscribe.submitYoutube")), '', {
                //   confirmButtonText: 'Confirm',
                //   callback: action => {
                //     this.$message({
                //       type: 'info',
                //       message: `action: ${ action }`
                //     });
                //   }
                // });
                this.operatorUser(ticketid);
                window.open(loginemail, "target");
                // this.showjoin = true;
            } else {
                MessageError("Please enter the Email");
                return;
            }
        },
        async operatorUser(ticketid) {
            this.form.userid = this.userinfo.id;
            this.form.typeid = 8;
            this.form.content = "Complete email:" + this.form.content;
            // 如果是邻国传的是item
            if (ticketid && ticketid.id) {
                this.form.ticketid = ticketid.id;
                if (ticketid.goodsname.toLowerCase().indexOf('duolinguo') > -1) {
                    this.form.content = "duo lin guo Complete email:" + this.form.content;
                } else if (ticketid.goodsname.toLowerCase().indexOf('team') > -1) {
                    this.form.content = "gpt team Complete email:" + this.form.content;
                } else if (ticketid.goodsname.toLowerCase().indexOf('youtube') > -1) {
                    this.form.content = "email:" + this.form.content + `\n` + "pwd:" + this.form.password + `\n` + "code1:" + this.form.code1 + `\n` + "code2:" + this.form.code2;
                } else if (ticketid.goodsname.toLowerCase().indexOf('chat gpt') > -1) {
                    this.form.content = "email:" + this.form.content + `\n` + "pwd:" + this.form.password;
                }
            } else {
                this.form.ticketid = ticketid;
            }
            // this.form.ticketid = ticketid;
            // this.form.typeid = 5;
            let res = await insertWorkorder(this.form);
            if (res.status == "200") {
                // MessageSuccess("처리 상태가 제출되었습니다. 작업 주문서에서 처리 상태를 확인하십시오.")
                // MessageSuccess("처리 상태가 제출되었습니다. 작업 주문서에서 처리 상태를 확인하십시오.")
                // MessageSuccess(this.$t("subscribe.processing")); 提交工单提示
                // this.form = this.initform();
                // this.$refs.ruleForm.clearValidate();
            } else {
                MessageError(res.msg);
            }
        },
        async submitWorkorder(typeid) {
            this.form.typeid = typeid;
            this.form.ticketid = this.item.id;
            const userInfo = JSON.parse(getUserInfo());
            this.form.userid = userInfo.id;
            if (typeid == 11) {
                this.form.content = "get new link email: " + this.form.email;
            } else if (typeid == 12) {
                this.form.content = "recharge to my account: " + this.form.email + `\n` + "pwd: " + this.form.password + `\n` + "code1: " + this.form.code1 + `\n` + "code2: " + this.form.code2;
            } else if (typeid == 13) {
                this.form.content = "use alongshare new account:  " + userInfo.email + `\n` + "carname: " +this.item.carname;
            } else if (typeid == 14) {
                this.form.content = "wait family group: " + userInfo.email + `\n` + "carname: " +this.item.carname;
            } else if (typeid == 15) {
                this.form.content = "Failure again after recovery: " + userInfo.email + `\n` + "carname: " +this.item.carname;
            }
            this.form.ext1 = this.times;
            let res = await insertWorkorder(this.form);
            if (res.status == "200") {
                // MessageSuccess("처리 상태가 제출되었습니다. 작업 주문서에서 처리 상태를 확인하십시오.")
                // MessageSuccess("처리 상태가 제출되었습니다. 작업 주문서에서 처리 상태를 확인하십시오.")
                // MessageSuccess(this.$t("subscribe.processing")); 提交工单提示
                this.form = this.initform();
                this.$refs.ruleForm.clearValidate();
                this.workorderflag=false;
            } else {
                MessageError(res.msg);
            }
        },
        async submitNewLink() {
            this.$confirmel('이 작업은 한 번만 가능합니다,계속 진행합니까?', 'tips', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.getNewLinkDialog = false;
                this.dialogFormVisible = false;
                this.submitWorkorder(11);
            }).catch(() => {
                //   this.$message.info('已取消')
                this.$message.info('Cancelled')
                this.getNewLinkDialog = false;
            });
        },
        async submitRechargeToMyAccount() {
            this.$confirmel('이 작업은 한 번만 가능합니다,계속 진행합니까?', 'tips', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                //   this.$message.success('提交成功!')
                this.$message.success('success!')
                this.rechargeToMyAccountDialog = false;
                this.dialogFormVisible = false;
                this.submitWorkorder(12);
            }).catch(() => {
                //   this.$message.info('已取消')
                this.$message.info('Cancelled')
                this.rechargeToMyAccountDialog = false;
            });
        },
        async submitUseAlongshareAccount() {
            this.$confirmel('이 작업은 한 번만 가능합니다,계속 진행합니까?', 'tips', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                //   this.$message.success('提交成功!')
                this.$message.success('success!')
                this.useAlongshareAccountDialog = false;
                this.dialogFormVisible = false;
                this.submitWorkorder(13);
            }).catch(() => {
                //   this.$message.info('已取消')
                this.$message.info('Cancelled')
                this.useAlongshareAccountDialog = false;
            });
        },
        async submitWaitFamilyGroup() {
            this.$confirmel('이 작업은 한 번만 가능합니다,계속 진행합니까?', 'tips', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.waitFamilyGroupDialog = false;
                this.dialogFormVisible = false;
                this.submitWorkorder(14);
            }).catch(() => {
                //   this.$message.info('已取消')
                this.$message.info('Cancelled')
                this.waitFamilyGroupDialog = false;
            });
        },
        async submitFailureAgainAfterRecovery() {
            this.$confirmel('이 작업은 한 번만 가능합니다,계속 진행합니까?', 'tips', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.failureAgainAfterRecoveryDialog = false;
                this.dialogFormVisible = false;
                this.submitWorkorder(15);
            }).catch(() => {
                //   this.$message.info('已取消')
                this.$message.info('Cancelled')
                this.failureAgainAfterRecoveryDialog = false;
            });
        },
        calcWidth() {
            this.screenWidth = window.screen.width;
            this.$forceUpdate();
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.calcWidth();
            window.addEventListener("resize", this.calcWidth);
        })
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.calcWidth);
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer {
    height: calc(100vh - 200px) !important;
    
    .header {
        display: flex;
        border-bottom: 1px solid #f5f2f2;
        padding: 20px;
        margin-bottom: 0;
    }
    
    &__body {
        padding-bottom: 76px !important;
    }
}

.drawer-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
}

.drawer-content {
    padding: 20px;
}

.body {
    padding: 20px;
}

.btn {
    width: 100%;
    margin: 0 !important;
    margin-bottom: 20px !important;
}

.tip {
    margin-bottom: 20px !important;
}

.how-use {
    right: 20px;
    position: absolute;
    top: 20px;
    color: #db4245;
    line-height: 18px;
    cursor: pointer;
}
.progress-container{
    display: flex;
     align-items: center;
    justify-content: center;
}

.dialog-footer {
    width: 100%;
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    background-color: white;
    border-top: 1px solid #f5f2f2;
    
    .cancel-btn {
        width: 30%;
    }
    
    .confirm-btn {
        width: 30%;
    }
    
    &.footer-btn {
        justify-content: flex-end;
    }
}
</style>